import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { getAuditTrail, type AuditTrailResponse } from '../api';
import { reviewerQueryKeys } from './useDocumentResult';

/**
 * Loads the audit trail of a document job from `GET /documents/{id}/audit-trail`.
 *
 * Lazy: callers pass `enabled: false` until the user opens the audit-trail panel
 * to avoid issuing the request on every reviewer page load. Once fetched the
 * data is immutable in practice (events are append-only) so we cache aggressively.
 */
export function useAuditTrail(
  jobId: string,
  options: { enabled?: boolean } = {},
): UseQueryResult<AuditTrailResponse> {
  return useQuery({
    queryKey: reviewerQueryKeys.auditTrail(jobId),
    queryFn: ({ signal }) => getAuditTrail(jobId, signal),
    enabled: (options.enabled ?? true) && jobId.length > 0,
    staleTime: 60_000,
    gcTime: 5 * 60_000,
    retry: 1,
  });
}
